import { createVanIconComponent } from "./van"

const Invitation = createVanIconComponent("invitation")
export default Invitation
